<!-- Responsibility: Display recent AI errors.
Scope: View-only card for error tail state. -->
<admin-error-tail-card>
  <section class="admin-card">
    <header>
      <h2>Error Tail</h2>
      <span class="admin-card-meta">Recent failed AI calls</span>
    </header>
    <ul if={ props.errorTail.length } class="error-tail">
      <li each={ entry in props.errorTail }>
        <strong>{ entry.provider }</strong>
        <span>{ entry.jobType }</span>
        <p>{ entry.error }</p>
      </li>
    </ul>
    <p if={ !props.errorTail.length } class="admin-copy">No recent failed AI telemetry entries.</p>
  </section>

  <style>
    .admin-card {
      display: grid;
      gap: var(--space-sm);
      border: 1px solid color-mix(in srgb, var(--border) 46%, transparent);
      border-radius: 1rem;
      padding: var(--space-md);
      background: var(--surface-raised);
      box-shadow: var(--shadow-elev-2);
    }

    header {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      gap: var(--space-sm);
    }

    h2 {
      margin: 0;
      color: var(--text-prose);
    }

    .admin-card-meta {
      font-size: var(--type-xs);
      color: var(--text-muted);
    }

    .admin-copy {
      color: var(--text-muted);
      font-size: var(--type-sm);
      margin: 0;
    }

    .error-tail {
      display: grid;
      gap: var(--space-xs);
      margin: 0;
      padding: 0;
      list-style: none;
    }

    .error-tail li {
      font-size: var(--type-xs);
      padding: var(--space-xs);
      border: 1px solid var(--border);
      border-radius: 0.25rem;
      background: color-mix(in srgb, var(--danger) 5%, transparent);
    }

    .error-tail strong {
      color: var(--danger);
    }
  </style>
</admin-error-tail-card>
